import React from 'react';

export const Tag = (props: React.HTMLAttributes<HTMLSpanElement>) => {
  return (
    <span className='p-2.5 bg-gray-light text-md sm:text-base font-semibold rounded-lg ring-2 ring-gray-medium'>
      {props.children}
    </span>
  );
};
